import React, { PropTypes, PureComponent } from 'react';
import SaveCancelModal from './SaveCancelModal';
import { Tip } from 'react-fast-ui';
import FormControl from '../inputs/FormControl';
import EmptyState from '../../common/components/EmptyState';
import TextInput from '../inputs/TextInput';
import cx from 'classnames';

class NumberInput extends PureComponent {
  focus = () => this.refs.input.focus();

  render() {
    const { className, ...rest } = this.props;

    return (
      <FormControl>

        <input className={cx(className, 'hide-number-input-arrows')} ref="input" pattern="\d*" type="number" {...rest}/>
      </FormControl>
    );
  }
}

class SideScoreForm extends PureComponent {
  static propTypes = {
    side: PropTypes.string.isRequired,
    value: PropTypes.shape({}).isRequired,
    onChange: PropTypes.func.isRequired
  };

  focusScore = () => this.refs.scoreInput.focus();

  render() {
    const { side, value = {}, onChange, ...rest } = this.props;

    return (
      <div {...rest}>
        <div className="font-lg"><strong>{side}:</strong> {value.team.name}</div>
        <hr className="mg-top-sm mg-bottom-sm"/>
        <div>
          <label>Score</label>
          <NumberInput
            ref="scoreInput"
            placeholder="Score"
            value={value.score && value.score.score ? value.score.score : ''}
            onChange={({ target: { value: score } }) => onChange({
              ...value,
              score: score && score.length ? { ...value.score, score } : null
            })}/>
        </div>
        <div className="mg-top-sm">
          <label>Notes</label>
          <TextInput
            disabled={!value.score || !value.score.score}
            value={value.score && value.score.notes ? value.score.notes : ''}
            placeholder="Score Notes"
            onChange={({ target: { value: notes } }) => onChange({ ...value, score: { ...value.score, notes } })}/>
        </div>
      </div>
    );
  }
}

class EnterScoreForm extends PureComponent {
  static propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func.isRequired
  };

  focusHomeScore = () => this.refs.homeScore.focusScore();
  focusVisitorScore = () => this.refs.visitorScore.focusScore();

  render() {
    const { value, onChange } = this.props;
    const changed = change => onChange({ ...value, ...change });

    const { sides } = value;

    if (!sides || !sides.home || !sides.visitor || !_.all(sides, side => !!side.team)) {
      return (
        <EmptyState iconProps={{ name: 'exclamation-triangle' }}>
          Game must have both teams assigned before a score is entered
        </EmptyState>
      );
    }

    const { home, visitor } = sides;

    return (
      <div className="display-flex align-items-center flex-wrap-wrap">
        <SideScoreForm side="Home" value={home} onChange={home => changed({ sides: { ...sides, home } })}
          ref="homeScore"
          className="flex-grow-1 mg-sm"/>
        <div className="flex-shrink-0 pd-lg hidden-xs hidden-sm"><strong><em>VS.</em></strong></div>
        <SideScoreForm side="Visitor" value={visitor} onChange={visitor => changed({ sides: { ...sides, visitor } })}
          ref="visitorScore"
          className="flex-grow-1 mg-sm"/>
      </div>
    );
  }
}

export default class EnterScoreModal extends PureComponent {
  static propTypes = {
    game: PropTypes.object,
    onChange: PropTypes.func.isRequired
  };

  static defaultProps = {};

  componentDidUpdate({ open }) {
    if (!open && this.props.open) {
      setTimeout(() => {
        const { enterScore } = this.refs;
        if (enterScore) {
          enterScore.focusHomeScore();
        }
      });
    }
  }

  render() {
    const { game, onChange, ...rest } = this.props;

    return (
      <SaveCancelModal title={game ? `Enter Score for ${game.name}` : ''}
        {...rest}>
        {game && <EnterScoreForm ref="enterScore" onChange={onChange} value={game}/>}
      </SaveCancelModal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/modals/EnterScoreModal.jsx